import Icon from '@components/icons/Icon';
import { IconButton, theme } from 'aimo-ui';
import { ButtonTypes } from 'aimo-ui/lib/typescript/src/components/Button/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViewProps } from 'react-native-svg/lib/typescript/fabric/utils';
import { testIdentifiers } from 'utils/testIdentifiers';

type CloseButtonProps = {
  onPress: () => void;
  testID?: string;
  buttonType?: ButtonTypes;
  size?: string;
  padding?: number;
} & ViewProps;

const CloseIcon = ({ color, size }: { color: string; size: string }) => (
  <Icon name="close" size={size} color={color} />
);

const CloseButton = ({
  onPress,
  testID,
  buttonType,
  size = 's',
  padding,
  ...props
}: CloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onLayout={props.onLayout}
      fullWidth={false}
      buttonType={buttonType}
      onPress={onPress}
      rounded
      padding={padding}
      {...testIdentifiers(testID as string)}
      accessibilityLabel={t('button.close')}
      iconComponent={() => (
        <CloseIcon
          size={size}
          color={
            buttonType === 'secondary' || buttonType === 'primary'
              ? theme.colors.white
              : theme.colors.gray300
          }
        />
      )}
    />
  );
};

export default CloseButton;
